const apis = {
	login: '/user/login', //登录
	register: "/user/register", //注册 
	forgetpwd: "/user/forgetpwd", //忘记密码
	resetPwd: "/user/resetPwd1", //重置密码
	userAllMoney: '/money/getUserAllMoney',//资产-资产总览
	accountData: '/money/getAccountData',//资产- 资产 合约 期权 理财 账户	
	getLegalData: '/money/getLegalData',//资产- 法币账户	
	orderTypeList: '/money/getOrderTypeList',//资产- 订单中心
	getOrderData: '/money/getOrderData',//资产- 订单中心列表
	totalEchart: '/money/getTotalEchart',//资产- 资产总览-资产走势图
	transferData: '/money/getTransferData',//资产- 划转下拉框
	transferList: '/money/getUserTransferList',//资产- 划转记录
	moneyTransfer: '/money/transfer',//资产- 划转提交
	getData: '/recharge/getData',//充值基础数据
	upload: '/common/upload',//图片上传
	getConfig: "common/getConfig",
	rechargeList: '/recharge/getRechargeList',//充值记录
	submit: '/recharge/submit',//充值提交

	withdrawData: '/withdraw/getData',//提现说明
	withdrawList: '/withdraw/getWithdrawList',//提现记录
	addressList: '/withdraw/getAddressList',//提现币种
	getUserInfo: '/user/getUserInfo',//用户数据
	getIndexData: "/index/getIndexData", //首页
	withdrawSubmit: '/withdraw/submit',//提币确定
	aiData: '/ai/getData',//ai量化基础数据
	aiInfo: '/ai/getInfo',//ai策略详情
	aiSubmit: '/ai/submit',//ai策略提交
	getUserOrderList: '/ai/getUserOrderList',//ai量化订单
	exchangeData: '/spot_order/getExchangeData',//闪兑数据
	exchangeRec: '/spot_order/getExchangeRec',//闪兑记录
	exchangeSubmit: '/spot_order/exchangeSubmit',//闪兑提交
	getTeamData: '/team/getTeamData',//邀请切换头部
	getInviteList: '/team/getInviteList',//邀请记录
	getOrderList: '/order/getOrderList',//交易期权 列表
	orderSubmit: '/order/submit',//交易期权 提交

	spotOrderList: '/spot_order/getSpotOrderList',//交易现货 列表
	spotOrderSubmit: '/spot_order/submit',//交易现货 提交
	cancelSpotOrder: '/spot_order/cancelSpotOrder',//交易现货 撤单

	contractOrder: '/contract_order/submit',//交易合约 提交
	contractOrderList: '/contract_order/getContractOrderList',//交易合约 列表
	closePositions: '/contract_order/closePositions',//交易合约 平仓
	cancelContractOrder: '/contract_order/cancelContractOrder',//交易合约 撤销

	mobileRegister: "/mobile/register", //快捷买币 记录

	getProductTypeList: "/product/getProductTypeList", //货币类型
	getProductList: "/product/getProductList", //产品列表
	getProductRank: "/product/getProductRank", //行情排名
	operateUserProduct: "user/operateUserProduct", //操作自选产品
	getProductInfo: "/product/getProductInfo", //交易产品详情
	getProductKline: "/product/getProductKline", //交易产品 k线数据

	getProductDepth: "/product/getProductDepth",
	recentOrder: "/order/recentOrder",

	getUserRealInfo: "/user/getUserRealInfo", //认证信息
	getCountryList: "/index/getCountryList", //国家列表
	basicReal: "/user/basicReal", //初级实名认证
	advancedReal: "/user/advancedReal", //高级实名认证

	getQuantCombineData: "/quant_order/getQuantCombineData", //组合投资 数据
	getQuantCombineInfo: "/quant_order/getQuantCombineInfo", //组合投资 详情
	quantOrderSubmit: "/quant_order/submit", //组合投资 申请
	getQuantOrderList: "/quant_order/getQuantOrderList", //组合投资 列表

	getTeamRuleList: "/team/getTeamRuleList", //团队等级
	getUserSpot: "/spot_order/getUserSpot", //余额接口
	richtextGetInfo: "/richtext/getInfo", //首页咨讯详情
	mobileReal: "/user/mobileReal", //实名认证
	borrowGetData: "/borrow/getData", //借币数据
	borrowSubmit: "/borrow/submit", //借币提交
	getBorrowOrderList: "/borrow/getBorrowOrderList", //借币记录
	borrowRepay: "/borrow/repay", //立即还款
	emsSend: "/ems/send", //获取验证码

	


};


// Object.keys(apis).forEach((key) => {
// 	if (process.env.NODE_ENV === "development") {
// 		apis[key] = `https://jy-zh3.hoteltu123.com/api/${apis[key]}`
// 	} else {
// 		apis[key] = `/api/${apis[key]}`
// 	}
// });

export default apis;